import * as Yup from 'yup';

export const fields = [
    {
        name: 'publicId',
        label: 'Скопируйте Public ID из настроек, вставьте в поле ниже',
        type: 'text',
        placeholder: 'Введите Public ID',
        position: 10,
    },
    {
        name: 'apiSecret',
        label: 'Добавьте пароль для API и нажмите “Сохранить”',
        type: 'password',
        placeholder: 'Введите пароль API',
        position: 10,
    },
];

export const validationSchema = Yup.object({
    publicId: Yup.string().required('Укажите ID'),
    apiSecret: Yup.string().required('Введите ключ'),
});

export const initialValues = {
    publicId: null,
    apiSecret: null,
};
